/**
 * Registers the <lesson-walkthrough> web component once, app-wide.
 * Imported for side effects from main.tsx. After this runs, the
 * <lesson-walkthrough> tag works anywhere the app renders HTML — a step JSON's
 * overview content area, or an html_content field in the builder — with no iframe.
 *
 * Loads the component from the static, same-origin file public/widgets/lesson-walkthrough.js
 * via a <script src>. This is the ONE plain-JS source of truth — no base64 bundle to
 * regenerate. The component self-guards against double-definition, and any
 * <lesson-walkthrough> elements already in the DOM auto-upgrade once the script loads.
 */
const WIDGET_SRC = '/widgets/lesson-walkthrough.js';

export function registerLessonWalkthrough(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  // Already defined (e.g. HMR re-import) — nothing to do.
  if (window.customElements && window.customElements.get('lesson-walkthrough')) return;
  // Script already injected and loading — don't add it twice.
  if (document.querySelector('script[data-lesson-walkthrough]')) return;
  try {
    const script = document.createElement('script');
    script.dataset.lessonWalkthrough = 'true';
    script.src = WIDGET_SRC;
    script.async = true;
    document.head.appendChild(script);
  } catch (e) {
    console.error('Failed to register <lesson-walkthrough>:', e);
  }
}

registerLessonWalkthrough();
